import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const DashboardToolbar = ({
  viewMode,
  onViewModeChange,
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  filterStatus,
  onFilterChange,
  onCreateNew,
  onOpenTemplates
}) => {
  const sortOptions = [
    { value: 'modified', label: 'Last Modified' },
    { value: 'created', label: 'Date Created' },
    { value: 'name', label: 'Name (A-Z)' },
    { value: 'status', label: 'Status' }
  ];

  const filterOptions = [
    { value: 'all', label: 'All Projects' },
    { value: 'published', label: 'Published' },
    { value: 'draft', label: 'Draft' },
    { value: 'archived', label: 'Archived' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 mb-6">
      <div className="flex flex-col lg:flex-row gap-4 lg:items-center lg:justify-between">
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          <div className="flex-1 min-w-0">
            <Input
              type="search"
              placeholder="Search projects..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full"
            />
          </div>
          <div className="flex gap-2">
            <div className="w-full sm:w-40">
              <Select
                options={sortOptions}
                value={sortBy}
                onChange={onSortChange}
                placeholder="Sort by"
              />
            </div>
            <div className="w-full sm:w-40">
              <Select
                options={filterOptions}
                value={filterStatus}
                onChange={onFilterChange}
                placeholder="Filter"
              />
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <div className="hidden lg:flex items-center gap-1 bg-muted rounded-lg p-1">
            <button
              onClick={() => onViewModeChange('grid')}
              className={`p-2 rounded transition-all duration-250 ${
                viewMode === 'grid' ?'bg-background text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
              }`}
              aria-label="Grid view"
            >
              <Icon name="LayoutGrid" size={18} />
            </button>
            <button
              onClick={() => onViewModeChange('list')}
              className={`p-2 rounded transition-all duration-250 ${
                viewMode === 'list' ?'bg-background text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
              }`}
              aria-label="List view"
            >
              <Icon name="List" size={18} />
            </button>
          </div>

          <Button
            variant="outline"
            size="default"
            iconName="Layers"
            iconPosition="left"
            onClick={onOpenTemplates}
            className="hidden sm:flex"
          >
            Templates
          </Button>

          <Button
            variant="default"
            size="default"
            iconName="Plus"
            iconPosition="left"
            onClick={onCreateNew}
          >
            <span className="hidden sm:inline">New Project</span>
            <span className="sm:hidden">New</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashboardToolbar;